import { ReactNode, useLayoutEffect, useState } from "react";
import { Box } from "@mui/material";

import useElementWidth from "hooks/useElementWidth";
import useResponsive from "hooks/useResponsive";
import { type BotsLayout, chooseBotsLayout } from "./botsTableLayout";

/**
 * A hand-built table (a job's nested tasks) under the BotsRecordTable rule: in
 * a container narrower than the table needs - a laptop with the users panel
 * open, a card on a phone - it shows its cards instead of scrolling sideways.
 */
export default function BotsFitLayout({
  minWidth,
  table,
  cards,
}: {
  minWidth: number;
  table: () => ReactNode;
  cards: () => ReactNode;
}) {
  const { isCardMode } = useResponsive();
  const [measureRef, width] = useElementWidth();
  const [layout, setLayout] = useState<BotsLayout>(isCardMode ? "cards" : "table");
  useLayoutEffect(() => {
    setLayout((previous) =>
      chooseBotsLayout({ cardMode: isCardMode, containerWidth: width, minWidth, previous }),
    );
  }, [isCardMode, width, minWidth]);
  return (
    <Box ref={measureRef} sx={{ minWidth: 0, width: "100%" }}>
      {layout === "cards" ? cards() : table()}
    </Box>
  );
}
